import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";
import {useMessages} from "i18n";
import {useThemeMode} from "theme/ThemeModeProvider";

/**
 * Light/dark mode toggle wired to the v3 {@link useThemeMode} context: flips both the MUI and
 * styled-components themes and persists the choice to localStorage (see ThemeModeProvider).
 *
 * The label names the mode it switches TO and is shared verbatim with the command palette's theme
 * command — one catalog entry, so the tooltip, the `aria-label` and the palette can never disagree
 * (ui#334; it was hardcoded English here, untranslated on transferify.ro).
 */
export default function DarkThemeToggle() {
	const {mode, toggleMode} = useThemeMode();
	const {commandPalette} = useMessages();
	const isDark = mode === "dark";
	const label = isDark ? commandPalette.theme.toLight : commandPalette.theme.toDark;
	return (
		<Tooltip title={label}>
			<IconButton aria-label={label} onClick={toggleMode} color="inherit" size="small">
				{isDark ? <LightModeOutlinedIcon fontSize="small"/> : <DarkModeOutlinedIcon fontSize="small"/>}
			</IconButton>
		</Tooltip>
	);
}
